var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._v(" 四川省人民政府口岸与物流办公室 Copyright2018 All Rights Reserve  "),_c('a',{staticStyle:{"color":"#939cb1","font-size":"16px"},attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("备案号：蜀ICP备12000086号-9")])])
}]

export { render, staticRenderFns }